'use client'

import { Check, CheckCircleOutline } from '../../../icons'
import { cn } from '../../../utils/cn'

export interface TimingOptionProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Radio group name
   */
  name: string

  value: string

  checked: boolean

  title: string

  description: string

  onChange?: (value: string) => void
}

/**
 * A card-style radio button, styled like the plan cards' selection states
 */
export const TimingOption = ({
  className,
  name,
  value,
  checked,
  title,
  description,
  onChange,
}: TimingOptionProps) => (
  <label
    className={cn(
      'flex w-full cursor-pointer items-center gap-4 rounded-md border border-solid p-4 transition-all has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-blue-03',
      checked ? 'border-red-01 bg-red-04' : 'border-gray-04 bg-white',
      className,
    )}
  >
    <input
      type="radio"
      className="sr-only"
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange?.(value)}
    />

    {checked ? (
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-red-01">
        <Check className="size-5 text-white" />
      </span>
    ) : (
      <CheckCircleOutline className="size-8 shrink-0 text-gray-05" />
    )}

    <span className="flex flex-1 flex-col text-gray-01">
      <span className="typography-subhead1">{title}</span>
      <span className="typography-body2">{description}</span>
    </span>
  </label>
)
